export default "__VITE_ASSET__930b90cd__"